export enum CoordinatorScreenKey {
  DONORS = "/donors",
  REPORTS = "/reports",
  SCHEDULE = "/schedule",
  DAY = "/day",
  ADD = "/add",
  MANUAL_DONATION = "/manual",
  APPOINTMENT = "/appointment",

  LOGIN = "/login",
  RESET_PASSWORD = "/resetPassword",
}
